import styled from "@emotion/styled";
import { Skeleton } from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import { getAgents, IAgentsFilters } from "api/agent.request";
import React, { useEffect } from "react";
import AgentCardLarge from "../agent-card-large";
import CustomCarrusel from "../custom-carrusel";
import { MessageResults } from "../messages-result";

function SliderAgentsCardLarge(props: { 
  filters?: IAgentsFilters,
  setHaveAgents?: any
}) {
  const fetchProjectSlider = async () => {
    const response = await getAgents({ page: 1, ...props.filters });
    return response;
  };

  const { data, status, isLoading, isError, mutate } = useMutation(
    ["agents-slider"],
    fetchProjectSlider
  );

  useEffect(() => {
    mutate();
  }, [props.filters]);


  props.setHaveAgents(!!!data || !!data?.data?.length ? true : false)

  if (data && data?.data?.length == 0 && isLoading) {
    return <></>;
  }

  if (isError) {
    return <MessageResults message="Ha ocurrido un error" />;
  }

  return (
    <section className="container">
      <CustomCarrusel
        placeholderItem={
          <Wrapper>
            <SkeletonAgent />
          </Wrapper>
        }
      >
        {data?.data.map((item: any, i) => (
          <Wrapper key={i}>
            <AgentCardLarge {...item}></AgentCardLarge>
          </Wrapper>
        ))}
      </CustomCarrusel>
    </section>
  );
}

export default SliderAgentsCardLarge;

const Wrapper = styled.div`
  display: flex !important;
  justify-content: center;
  padding: 10px 5px;
`;

const SkeletonAgent = () => {
  return (
    <div style={{ width: 270 }}>
      <Photo variant="rectangular" />
      <Name variant="rounded" />
      <Text variant="rounded" width={210} />
      <Text variant="rounded" width={220} />
      <div style={{ display: "flex" }}>
        <Red variant="circular" />
        <Red variant="circular" />
        <Red variant="circular" />
        <Red variant="circular" />
      </div>
    </div>
  );
};
const Photo = styled(Skeleton)`
  width: 270px;
  height: 200px;
  border-radius: 15px;
  margin-bottom: 10px;
`;
const Name = styled(Skeleton)`
  width: 260px;
  height: 20px;
  margin-bottom: 10px;
`;

const Text = styled(Skeleton)`
  height: 20px;
  margin-bottom: 10px;
`;

const Red = styled(Skeleton)`
  width: 30px;
  height: 30px;
  margin-right: 30px;
`;
